/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { FormattedNumber } from "react-intl";
import { Menu, MenuItem } from "../../state/types/menuTypes";
import MissingOptionModal from "../Modal/MissingOptionModal";
import {
  uniqueModifierKey,
  deriveModifierGroupsFromMenu,
  DerivedModifierGroup,
} from "../../hooks/useModifierSelection";

export interface IMenuItemOptionsProps {
  modifierGroupIds: ReadonlyArray<number>;
  selectedOption: {}[];
  onOptionAdded: (option: {}[]) => void;
  onAddToOrderClick: (selectedOption: {}[]) => void;
  menu: Menu;
  menuItem: MenuItem;
  menuItemAddToOrderButtonRef: React.MutableRefObject<HTMLButtonElement | null>;
}

export default class MenuItemOptions extends React.Component<
  IMenuItemOptionsProps,
  any
> {
  readonly btnSelectedClass = "btn-selected";
  readonly btnWhiteClass = "btn-white";
  readonly btnOrangeClass = "btn-orange-toggle";

  selectedOptions: {}[];

  constructor(props: IMenuItemOptionsProps) {
    super(props);
    this.setSelectedOption = this.setSelectedOption.bind(this);
    this.onAddToOrderClick = this.onAddToOrderClick.bind(this);
    this.selectedOptions = props.selectedOption;

    this.state = {
      defaultOption: {},
    };
  }

  componentDidMount() {
    const modifierGroupsDerived = deriveModifierGroupsFromMenu(
      this.props.modifierGroupIds,
      this.props.menu
    );
    this.selectedOptions = [];

    const defaultOption = modifierGroupsDerived.reduce(
      (acc: any, mg: DerivedModifierGroup) => {
        const defaultModifier = mg.modifiers.find(
          (m: any) => m?.id === mg.defaultModifierId
        );

        if (defaultModifier !== undefined) {
          return {
            ...acc,
            [mg.id]: {
              id: defaultModifier.id,
              name: defaultModifier.name,
              groupName: mg.name,
              groupId: mg.id,
              price: defaultModifier.price,
            },
          };
        }

        return {
          ...acc,
          [mg.id]: {
            id: null,
            price: {},
          },
        };
      },
      {}
    );

    this.setState({
      defaultOption: defaultOption,
      validations: {},
    });

    Object.keys(defaultOption).forEach((modifierGroupId) => {
      this.setSelectedOption(
        modifierGroupId,
        defaultOption[modifierGroupId as any]
      );
    });
  }

  setSelectedOption(modifierGroupId: any, modifier: any) {
    const modifierGroup = this.props.menu.modifierGroups.find(
      (mg: any) => mg.id === modifierGroupId
    );

    const maximumChoices = modifierGroup ? modifierGroup.maximumChoices : 0;

    const selectedModifiers = this.selectedOptions.filter(
      (m: any) => m.groupId === modifierGroupId
    );

    const isNotDuplicateModifier = !this.selectedOptions
      .map((o) => uniqueModifierKey(o))
      .includes(uniqueModifierKey(modifier));

    if (selectedModifiers.length === maximumChoices && maximumChoices > 0) {
      // Allow de-selection of the same modifier;
      if (!isNotDuplicateModifier) {
        this.selectedOptions = this.selectedOptions.filter(
          (m: any) => m.id !== modifier.id || m.groupId !== modifier.groupId
        );

        this.props.onOptionAdded(this.selectedOptions);
      }

      // Do not allow new modifier to be added if maximum choice reached.
      // Patron has to deselect one of the modifier to select new one again.
      return;
    }

    if (isNotDuplicateModifier) {
      const selectedOptions = this.selectedOptions;
      if (modifier.id) {
        this.selectedOptions = [...selectedOptions, modifier];
      }
      this.props.onOptionAdded(this.selectedOptions);
    } else {
      this.selectedOptions = this.selectedOptions.filter(
        (m: any) => m.id !== modifier.id || m.groupId !== modifier.groupId
      );

      this.props.onOptionAdded(this.selectedOptions);
    }
  }

  onAddToOrderClick(selectedModifiers: {}[]) {
    const modifierGroupsDerived = deriveModifierGroupsFromMenu(
      this.props.modifierGroupIds,
      this.props.menu
    );

    const requiredModifierGroups = modifierGroupsDerived.filter(
      (mg: DerivedModifierGroup) => mg.minimumChoices > 0
    );

    const requiredGroupIds = requiredModifierGroups.map(
      (mg: DerivedModifierGroup) => mg.id
    );

    const selectedGroupIds = selectedModifiers.map((m: any) => m.groupId);

    const missingGroupIds = requiredGroupIds.filter(
      (id) => !selectedGroupIds.includes(id)
    );

    if (missingGroupIds.length === 0) {
      this.props.onAddToOrderClick(selectedModifiers);
    } else {
      this.setState({
        missingGroupIds: missingGroupIds,
      });
    }
  }

  renderOptionButton(
    modifierGroup: DerivedModifierGroup,
    onClick: (option: any, value: any) => void
  ) {
    const selectedModifierInGroup = this.selectedOptions.find(
      (m: any) => m.groupId === modifierGroup.id
    );

    const selectedModifier =
      selectedModifierInGroup || this.state.defaultOption[modifierGroup.id];

    return (
      <div className="col modifier-container" key={modifierGroup.id}>
        {selectedModifier ? (
          <div>
            <label>
              {modifierGroup.name}
              {modifierGroup.minimumChoices > 0 ? "*" : ""}
              {modifierGroup.maximumChoices > 0
                ? ` (max choice: ${modifierGroup.maximumChoices})`
                : ""}
            </label>
            {modifierGroup.modifiers
              .sort(
                (a: any, b: any) =>
                  (a?.displayOrder || 0) - (b?.displayOrder || 0)
              )
              .filter((modifier: any) => modifier?.visible)
              .map((modifier: any) => (
                <button
                  key={modifier.id}
                  className={`btn-default btn-modifier ${
                    this.selectedOptions
                      .map((o) => uniqueModifierKey(o))
                      .includes(uniqueModifierKey(modifier))
                      ? this.btnOrangeClass
                      : this.btnWhiteClass
                  }`}
                  onClick={() => onClick(modifierGroup.id, modifier)}
                >
                  {modifier.name + " "}
                  {modifier.price.amount > 0 ? (
                    <span>
                      {modifier.price.currencySymbol}
                      <FormattedNumber
                        minimumFractionDigits={2}
                        value={modifier.price.amount}
                      />
                    </span>
                  ) : null}{" "}
                </button>
              ))}
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { selectedOption } = this.props;
    const modifierGroupsDerived = deriveModifierGroupsFromMenu(
      this.props.modifierGroupIds,
      this.props.menu
    );

    const missingModifierGroups = this.props.menu.modifierGroups.filter(
      (group) => this.state.missingGroupIds?.includes(group.id)
    );

    const visibleModifierGroups = modifierGroupsDerived
      .filter(
        (mg: DerivedModifierGroup) =>
          mg.visible && mg.modifiers.filter((m: any) => m?.visible).length > 0
      )
      .sort(
        (mg1: DerivedModifierGroup, mg2: DerivedModifierGroup) =>
          mg1.displayOrder - mg2.displayOrder
      );

    return (
      <div className="item-extras fast-transform">
        <div className="row-finish">
          <button
            ref={this.props.menuItemAddToOrderButtonRef}
            onClick={() => this.onAddToOrderClick(selectedOption)}
            className="btn btn-primary btn-done"
          >
            Add to Order
          </button>
        </div>
        <div className="item-extra">
          <div className="menu-modifier row">
            {visibleModifierGroups.map((modifierGroup: DerivedModifierGroup) =>
              this.renderOptionButton(modifierGroup, this.setSelectedOption)
            )}
          </div>
        </div>
        {missingModifierGroups?.length > 0 ? (
          <MissingOptionModal
            onDismiss={() => this.setState({ missingGroupIds: [] })}
            missingModifierGroups={missingModifierGroups}
          />
        ) : (
          <></>
        )}
      </div>
    );
  }
}
